module.exports = __webpack_public_path__ + "static/media/DESC_PRATICANDO_ARQUITETURA_DE_INTEGRACAO_COM_APACHE_KAFKA_SERVICE_MESH_ISTIO_API_E_MONGODB-06.65984d6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/praticando/DESC_PRATICANDO_ARQUITETURA_DE_INTEGRACAO_COM_APACHE_KAFKA_SERVICE_MESH_ISTIO_API_E_MONGODB-06.png
// module id = 285
// module chunks = 0